import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useTranslation } from "react-i18next";
import { Button, colors } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
        minHeight:400

    },
}));

export default function IntermediateAccTable(props) {
    const { 
        paramsSubList,
        rptParams,
        setParamsSubList,
        selectRow,
        openSearchMdl,
        setOpenSearchMdl,
    } = props;


    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 16,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#000"
    }
    const data = paramsSubList.map((row,i) => {
        return {
          ...row,
         no: i,
        };
      });
     
    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    useEffect(() => {
        // console.log("units is", currUnitList)
    }, [paramsSubList]);

    return (
        <TableContainer component={Paper} >
            <Table
                //className={classes.table} 
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: colors.grey[700],
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 17,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell  style={stylH} hidden={true} align="center">
                            {t("no")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("description")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("account-code")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("account-name")}
                        </TableCell>
                        
                        <TableCell style={stylH} align="center">
                            {t("action")}
                        </TableCell>
                       
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row) => (
                        <TableRow key={row.no}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 17,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo}  align="center"  >{row.no+1}</TableCell>
                            <TableCell style={stylRo} align="center" >{row.Intermediate_name}</TableCell>

                            <TableCell style={stylRo} align="center" >{row.Intermediate_acc_no}</TableCell>

                            <TableCell style={stylRo} align="center" >{row.Intermediate_acc_name}</TableCell>
                            <TableCell style={stylRo} align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                       selectRow(row);
                                    }}
                                   style={{backgroundColor:"#fff" ,color:"#000" ,fontWeight:"bold"}}
                                >
                                    {t("change")}
                                </Button>
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>

            </Table>
            
        </TableContainer>
        
    );
}
